import axios from "axios";
import { constants } from "../config";

export default class MissionService {
  static async get(page, limit) {
    return axios
      .get(constants.api + "/mission-requests/" + page, {
        params: {
          limit: limit ? limit : null,
        },
      })
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }
  static async getTitle() {
    return axios
      .get(constants.api + "/mission-request-title-flight")
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }

  static async getById(id) {
    return axios
      .get(constants.api + "/mission-request/" + id)
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }

  static async search(search, page, limit) {
    return axios
      .post(
        constants.api + "/mission-request-search/" + page,
        { search },
        {
          params: {
            limit: limit ? limit : null,
          },
        }
      )
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }

  static async customSearch(search) {
    return axios
      .post(constants.api + "/mission-request-custom-search/1", search)
      .then((response) => {
        if (response.status) {
          //console.log('tools:',search)
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }

  static async getByStatus(search, limit, page) {
    return axios
      .get(constants.api + "/mission-requests-bystatus/" + search, {
        params: {
          limit: limit ? limit : null,
          page: page ? page : null,
        },
      })
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }

  static async update(id, data) {
    return axios
      .put(constants.api + "/mission-request/" + id, data)
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }
  static async create(data) {
    return axios
      .post(constants.api + "/mission-request", data)
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }
}



// WEBPACK FOOTER //
// ./src/tools/MissionService.js